import styled from 'styled-components';
import { PrimaryDescription } from '../PrimaryDescription/PrimaryDescription';

export const CMInputLabel = styled(PrimaryDescription)`
  font-weight: 400;
  margin-bottom: 0.5rem;
`;
